"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DOM = _interopRequireDefault(require("../../../../display/DOM"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popup =
/** @class */
function () {
  function Popup(coordinate) {
    if (!document) return;
    var target = (0, _DOM.default)('<div class="aeris__openlayers__popup"></div>');
    this._container = target; // this._container.css({
    // 	background: 'rgba(0, 0, 0, 0.9)',
    // 	borderRadius: '6px',
    // 	bottom: '100%',
    // 	color: '#fff',
    // 	display: 'block',
    // 	fontSize: '11px',
    // 	fontWeight: 'normal',
    // 	left: '50%',
    // 	lineHeight: '14px',
    // 	marginBottom: '15px',
    // 	marginLeft: '-100px',
    // 	opacity: 0,
    // 	padding: '8px 10px',
    // 	pointerEvents: 'none',
    // 	position: 'absolute',
    // 	transition: 'opacity .2s ease-out',
    // 	width: '200px',
    // 	zIndex: 10000,
    // 	'-webkit-font-smoothing': 'antialiased'
    // });

    this._overlay = new ol.Overlay({
      insertFirst: true,
      element: target[0],
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
        source: null
      }
    });

    if (coordinate) {
      this.setCoordinate(coordinate);
    }
  }

  Popup.prototype.addTo = function (map) {
    this._map = map;
    map.addOverlay(this._overlay); // adjust left margin now that we have a valid width for the content

    var w = this._container.width();

    if (w > 0) {
      this._container.css({
        marginLeft: "-" + Math.round(w / 2) + "px"
      });
    }
  };

  Popup.prototype.remove = function () {
    if (this._map) {
      this._map.removeOverlay(this._overlay);
    }
  };

  Popup.prototype.setCoordinate = function (coord) {
    var _a = ol.proj.fromLonLat([coord.lon, coord.lat]),
        x = _a[0],
        y = _a[1];

    this._overlay.setPosition([Math.round(x), Math.round(y)]);
  };

  Popup.prototype.setHTML = function (html) {
    this._container.html(html);
  };

  Popup.prototype.setDOMContent = function (node) {
    this._container.empty().append(node);
  };

  Popup.injectStyles = function () {
    var css = "\n\t\t\t.aeris__openlayers__popup {\n\t\t\t\tbackground: #fff;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\tbottom: 100%;\n\t\t\t\tcolor: #222;\n\t\t\t\tdisplay: block;\n\t\t\t\tfilter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));\n\t\t\t\tfont-family: 'Helvetica','Arial',sans-serif;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tfont-weight: normal;\n\t\t\t\tleft: 50%;\n\t\t\t\tline-height: 14px;\n\t\t\t\tmargin-bottom: 15px;\n\t\t\t\tmargin-left: -100px;\n\t\t\t\tmin-width: 120px;\n\t\t\t\tpadding: 8px 10px;\n\t\t\t\tpointer-events: none;\n\t\t\t\tposition: absolute;\n\t\t\t\ttransition: opacity .2s ease-out;\n\t\t\t\tz-index: 10000;\n\t\t\t\t-webkit-font-smoothing: antialiased\n\t\t\t}\n\n\t\t\t.aeris__openlayers__popup:after {\n\t\t\t\tborder-left: solid transparent 10px;\n\t\t\t\tborder-right: solid transparent 10px;\n\t\t\t\tborder-top: solid #fff 10px;\n\t\t\t\tbottom: -10px;\n\t\t\t\tcontent: \" \";\n\t\t\t\theight: 0;\n\t\t\t\tleft: 50%;\n\t\t\t\tmargin-left: -9px;\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 0\n\t\t\t}\n\t\t";
    (0, _DOM.default)('head').append("<style type=\"text/css\">" + css + "</style>");
  };

  return Popup;
}();

var _default = Popup;
exports.default = _default;
module.exports = exports.default;